import { Component, Input } from '@angular/core';
import { zip } from 'rxjs';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveFileFormHeaderInfo } from 'src/app/modules/shared/models/archive/archive-file-form-header-info.model';
import { ArchiveFileSyncRuleType } from 'src/app/modules/shared/models/archive/archive-file-sync-rule-type.enum';
import { ArchiveFileTitleRuleFormInfoType } from 'src/app/modules/shared/models/archive/archive-file-title-rule-form-info-type.enum';
import { ArchiveFileTitleRuleFormInfo } from 'src/app/modules/shared/models/archive/archive-file-title-rule-form-info.model';
import { ArchiveFileTitleRule } from 'src/app/modules/shared/models/archive/archive-file-title-rule.model';
import { ArchiveMaterialInfo } from 'src/app/modules/shared/models/archive/archive-material-info.enum';
import { ArchiveTitleRuleItemInfo } from 'src/app/modules/shared/models/archive/archive-title-rule-item-info.model';
import { ArchiveTitleRuleItemParamInfo } from 'src/app/modules/shared/models/archive/archive-title-rule-item-param-info.model';
import { ArchiveTitleRuleItemParamType } from 'src/app/modules/shared/models/archive/archive-title-rule-item-param-type.enum';
import { ArchiveTitleRuleItemType } from 'src/app/modules/shared/models/archive/archive-title-rule-item-type.enum';
import { ArchiveVolumeCreateType } from 'src/app/modules/shared/models/archive/archive-volume-create-type.enum';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { ArchiveFileFormHeaderService } from 'src/app/modules/shared/services/archive-file-form-header.service';
import { ArchiveFileTitleRuleService } from 'src/app/modules/shared/services/archive-file-title-rule.service';

@Component({
  selector: 'app-dialog-projects-profiles-volumn-title-rule',
  templateUrl: './dialog-projects-profiles-volumn-title-rule.component.html',
  styleUrls: ['./dialog-projects-profiles-volumn-title-rule.component.scss'],
})
export class DialogProjectsProfilesVolumnTitleRuleNonWbsComponent {
  @Input()
  data!: DialogConfig<ArchiveCatalog>;

  editing: { [name: string]: boolean } = {};

  catalog: ArchiveCatalog = new ArchiveCatalog();

  record = new ArchiveFileTitleRule();

  ArchiveVolumeCreateType = ArchiveVolumeCreateType;

  ruleItemMap: { [key: string]: ArchiveTitleRuleItemParamInfo } = {};

  ArchiveTitleRuleItemType = ArchiveTitleRuleItemType;

  ArchiveTitleRuleItemParamType = ArchiveTitleRuleItemParamType;

  exampleName = '';

  headers: ArchiveFileFormHeaderInfo[] = [];

  materialTypeRule: ArchiveTitleRuleItemInfo = {
    type: ArchiveTitleRuleItemType.MATERIAL,
    formHeaderName: ArchiveMaterialInfo.MATERIAL_TYPE.toString(),
    params: [
      {
        type: ArchiveTitleRuleItemParamType.ITEM_NAME,
        checked: false,
        separator: '',
      },
    ],
  };

  materialModelRule: ArchiveTitleRuleItemInfo = {
    type: ArchiveTitleRuleItemType.MATERIAL,
    formHeaderName: ArchiveMaterialInfo.MATERIAL_MODEL.toString(),
    params: [
      {
        type: ArchiveTitleRuleItemParamType.ITEM_NAME,
        checked: false,
        separator: '',
      },
    ],
  };

  materialBatchRule: ArchiveTitleRuleItemInfo = {
    type: ArchiveTitleRuleItemType.MATERIAL,
    formHeaderName: ArchiveMaterialInfo.MATERIAL_BATCH.toString(),
    params: [
      {
        type: ArchiveTitleRuleItemParamType.ITEM_NAME,
        checked: false,
        separator: '',
      },
    ],
  };

  submitDateRule: ArchiveTitleRuleItemInfo = {
    type: ArchiveTitleRuleItemType.SUBMIT_DATE,
    formHeaderName: 'submitDate',
    params: [
      {
        type: ArchiveTitleRuleItemParamType.ITEM_NAME,
        checked: false,
        separator: '',
      },
    ],
  };

  finishDateRule: ArchiveTitleRuleItemInfo = {
    type: ArchiveTitleRuleItemType.FINISH_DATE,
    formHeaderName: 'finishDate',
    params: [
      {
        type: ArchiveTitleRuleItemParamType.ITEM_NAME,
        checked: false,
        separator: '',
      },
    ],
  };

  hasMaterial = false;

  forceUpdate = true;

  constructor(
    private archiveFileTitleRuleService: ArchiveFileTitleRuleService,
    private archiveFileFormHeaderService: ArchiveFileFormHeaderService,
    private globalService: GlobalService,
  ) {}

  fileTitleRuleFormInfosCode: ArchiveFileTitleRuleFormInfo = {
    type: ArchiveFileTitleRuleFormInfoType.FORM_CODE,
    checked: false,
    separator: '',
  };

  fileTitleRuleFormInfosName: ArchiveFileTitleRuleFormInfo = {
    type: ArchiveFileTitleRuleFormInfoType.FORM_NAME,
    checked: false,
    separator: '',
  };

  fileTitleRuleFormInfosSn: ArchiveFileTitleRuleFormInfo = {
    type: ArchiveFileTitleRuleFormInfoType.FORM_SN,
    checked: false,
    separator: '',
  };

  ngOnInit() {
    this.handleDataBeforeInit(this.data.data!);
  }

  genExampleName() {
    setTimeout(() => {
      let exampleName = '';
      if (this.fileTitleRuleFormInfosCode.checked) {
        exampleName += 'GL105' + this.fileTitleRuleFormInfosCode.separator;
      }
      if (this.fileTitleRuleFormInfosName.checked) {
        exampleName +=
          '分项工程检验申请和中间交验审批批表' +
          this.fileTitleRuleFormInfosName.separator;
      }
      if (this.fileTitleRuleFormInfosSn.checked) {
        exampleName += '20250610001' + this.fileTitleRuleFormInfosSn.separator;
      }
      for (const header of this.headers) {
        if (!!header.nameRuleChecked) {
          exampleName += '[' + header.name! + ']' + (header.separator ?? '');
        }
      }

      if (this.materialTypeRule.params![0].checked) {
        exampleName +=
          '钢筋' + (this.materialTypeRule.params![0].separator ?? '');
      }

      if (this.materialModelRule.params![0].checked) {
        exampleName +=
          'HPB300Φ10' + (this.materialModelRule.params![0].separator ?? '');
      }

      if (this.materialBatchRule.params![0].checked) {
        exampleName +=
          'ZJJG-GJ-Φ10-0001' +
          (this.materialModelRule.params![0].separator ?? '');
      }

      if (this.submitDateRule.params![0].checked) {
        exampleName +=
          '2023-02-28' + (this.submitDateRule.params![0].separator ?? '');
      }

      if (this.finishDateRule.params![0].checked) {
        exampleName +=
          '2023-03-20' + (this.finishDateRule.params![0].separator ?? '');
      }

      this.exampleName = `${this.record.titleFixedPrefix ?? ''}${exampleName}${
        this.record.titleFixedSuffix ?? ''
      }`;

      // 不要删。下面这段代码是为了确保变更检测机制能检测到titleRule的变化，从而更新界面显示的值。
      const titleAutoParts: Array<ArchiveTitleRuleItemInfo> = [];
      for (const header of this.headers) {
        const info = new ArchiveTitleRuleItemInfo();
        info.type = ArchiveTitleRuleItemType.FORM_FREE_HEAD;
        info.formHeaderName = header.name;
        info.params = [
          {
            type: ArchiveTitleRuleItemParamType.ITEM_NAME,
            checked: !!header.nameRuleChecked,
            separator: header.separator,
          },
        ];
        titleAutoParts.push(info);
      }
      this.record.titleAutoParts = titleAutoParts;
    }, 50);
  }

  private handleDataBeforeInit(response: ArchiveCatalog) {
    this.catalog = JSON.parse(JSON.stringify(response)) as ArchiveCatalog;
    for (const rule of this.catalog.fileSyncRules ?? []) {
      if (
        rule.type === ArchiveFileSyncRuleType.MATERIAL &&
        rule.checked &&
        rule.content
      ) {
        this.hasMaterial = true;
      }
    }
    zip(
      this.archiveFileFormHeaderService.findOne({
        catalogId: this.catalog.id!,
      }),
      this.archiveFileTitleRuleService.findOne({
        catalogId: this.catalog.id!,
      }),
    ).subscribe(([headerInfo, titleRule]) => {
      const headers =
        headerInfo.formHeaders?.filter((header) => header.participateTitle) ??
        [];
      if (titleRule) {
        this.record = titleRule;
        for (const item of this.record.titleAutoParts ?? []) {
          if (item.type === ArchiveTitleRuleItemType.FORM_FREE_HEAD) {
            for (const header of headers) {
              if (header.name === item.formHeaderName) {
                if (item.params && item.params.length > 0) {
                  header.nameRuleChecked = item.params[0].checked;
                  header.separator = item.params[0].separator;
                }
              }
            }
          }
          if (item.type === ArchiveTitleRuleItemType.MATERIAL) {
            if (
              item.formHeaderName ===
              ArchiveMaterialInfo.MATERIAL_TYPE.toString()
            ) {
              if (item.params && item.params.length > 0) {
                this.materialTypeRule.params![0].checked =
                  item.params[0].checked;
                this.materialTypeRule.params![0].separator =
                  item.params[0].separator;
              }
            }
            if (
              item.formHeaderName ===
              ArchiveMaterialInfo.MATERIAL_MODEL.toString()
            ) {
              if (item.params && item.params.length > 0) {
                this.materialModelRule.params![0].checked =
                  item.params[0].checked;
                this.materialModelRule.params![0].separator =
                  item.params[0].separator;
              }
            }
            if (
              item.formHeaderName ===
              ArchiveMaterialInfo.MATERIAL_BATCH.toString()
            ) {
              if (item.params && item.params.length > 0) {
                this.materialBatchRule.params![0].checked =
                  item.params[0].checked;
                this.materialBatchRule.params![0].separator =
                  item.params[0].separator;
              }
            }
          }
          if (item.type === ArchiveTitleRuleItemType.SUBMIT_DATE) {
            if (item.params && item.params.length > 0) {
              this.submitDateRule.params![0].checked = item.params[0].checked;
              this.submitDateRule.params![0].separator =
                item.params[0].separator;
            }
          }
          if (item.type === ArchiveTitleRuleItemType.FINISH_DATE) {
            if (item.params && item.params.length > 0) {
              this.finishDateRule.params![0].checked = item.params[0].checked;
              this.finishDateRule.params![0].separator =
                item.params[0].separator;
            }
          }
        }
      }
      this.headers = headers;
      for (const formInfo of this.record.fileTitleRuleFormInfos ?? []) {
        switch (formInfo.type) {
          case ArchiveFileTitleRuleFormInfoType.FORM_CODE:
            this.fileTitleRuleFormInfosCode = formInfo;
            break;
          case ArchiveFileTitleRuleFormInfoType.FORM_NAME:
            this.fileTitleRuleFormInfosName = formInfo;
            break;
          case ArchiveFileTitleRuleFormInfoType.FORM_SN:
            this.fileTitleRuleFormInfosSn = formInfo;
            break;
        }
      }
      setTimeout(() => {
        this.genExampleName();
      }, 100);
    });
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  get canConfirm() {
    return true;
  }

  private submit() {
    const titleAutoParts: Array<ArchiveTitleRuleItemInfo> = [];
    for (const header of this.headers) {
      const info = new ArchiveTitleRuleItemInfo();
      info.type = ArchiveTitleRuleItemType.FORM_FREE_HEAD;
      info.formHeaderName = header.name;
      info.params = [
        {
          type: ArchiveTitleRuleItemParamType.ITEM_NAME,
          checked: !!header.nameRuleChecked,
          separator: header.separator,
        },
      ];
      titleAutoParts.push(info);
    }
    if (this.hasMaterial) {
      titleAutoParts.push(this.materialTypeRule);
      titleAutoParts.push(this.materialModelRule);
      titleAutoParts.push(this.materialBatchRule);
    }
    titleAutoParts.push(this.submitDateRule);
    titleAutoParts.push(this.finishDateRule);
    this.record.titleAutoParts = titleAutoParts;
    this.record.forceUpdate = this.forceUpdate;
    if (!this.record.id) {
      this.record.catalogId = this.catalog.id!;
      this.record.projectId = this.globalService.projectId;
      this.record.fileTitleRuleFormInfos = [
        this.fileTitleRuleFormInfosCode,
        this.fileTitleRuleFormInfosName,
        this.fileTitleRuleFormInfosSn,
      ];
      this.archiveFileTitleRuleService
        .create(this.record)
        .subscribe((response) => {
          if (response) {
            this.data.onConfirm!();
          }
        });
    } else {
      this.record.fileTitleRuleFormInfos = [
        this.fileTitleRuleFormInfosCode,
        this.fileTitleRuleFormInfosName,
        this.fileTitleRuleFormInfosSn,
      ];
      this.archiveFileTitleRuleService
        .update(this.record)
        .subscribe((response: boolean) => {
          if (response) {
            this.data.onConfirm!();
          }
        });
    }
  }
}
